module.exports = __webpack_public_path__ + "static/1-fe9c644f3e1e72517416229d64f3da85.jpg";